import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionPath?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionPath,
  children,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-[0.18em] text-accent-700">
            <span className="h-[2px] w-4 bg-accent-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="text-xl font-semibold tracking-tight text-foreground-950 md:text-[22px]">{title}</h2>
        {description && <p className="mt-1.5 max-w-2xl text-[13px] leading-6 text-foreground-600">{description}</p>}
      </div>
      <div className="flex shrink-0 items-center gap-3">
        {children}
        {actionLabel && actionPath && (
          <Link
            to={actionPath}
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-[12px] text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            {actionLabel}
            <i className="ri-arrow-right-line text-xs" />
          </Link>
        )}
      </div>
    </div>
  );
}